import axios from "axios";
import {AppService} from "@/service/app.service";

export const AxiosService={

    async post(url,__params){
        return await axios.post(url,__params)
    },


    async get(url,__params){
        let queryString="";
        if(__params){
            queryString=AppService.generateQueryString(__params)
        }
        return await axios.get(url + queryString)
    }
}